var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 107,
    viewBox: "0 0 172 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2981 61.1338C38.9176 61.1338 37.7994 62.246 37.7994 63.6171C37.7994 64.9882 38.9176 66.1004 40.2981 66.1004C41.6777 66.1004 42.7959 64.9882 42.7959 63.6171C42.7959 62.246 41.6777 61.1338 40.2981 61.1338Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.357 104.391L310.296 103.456L286.406 79.7137L175.511 79.7137L146.602 50.9824L59.1344 50.9824L59.1344 52.3033L146.052 52.3033L174.961 81.0346L285.855 81.0346L309.357 104.391Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2513 54.3875C57.8717 54.3875 56.7527 53.2762 56.7527 51.9042C56.7527 50.5331 57.8717 49.4209 59.2513 49.4209C60.6309 49.4209 61.75 50.5331 61.75 51.9042C61.75 53.2762 60.6309 54.3875 59.2513 54.3875Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.08 79.7338L376.171 79.7338L376.171 78.4121L318.63 78.4121L292.566 52.5084L193.519 52.5084L155.841 15.0644L14.5837 15.0644L14.5837 16.3853L155.291 16.3853L192.968 53.8293L292.016 53.8293L318.08 79.7338Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7132 18.4685C13.3336 18.4685 12.2154 17.3563 12.2154 15.9852C12.2154 14.6141 13.3336 13.502 14.7132 13.502C16.0937 13.502 17.2119 14.6141 17.2119 15.9852C17.2119 17.3563 16.0937 18.4685 14.7132 18.4685Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.837 28.0077L314.777 27.0734L286.634 -0.895289L237.587 -0.895293L220.645 -17.7315L81.3998 -17.7315L81.3998 -16.4106L220.095 -16.4106L237.037 0.425605L286.084 0.425609L313.837 28.0077Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.747 64.674L236.639 64.674L247.54 53.8373L246.601 52.903L236.089 63.3531L179.297 63.3531L143.28 27.5576L90.8782 27.5576L90.8782 28.8785L142.729 28.8785L178.747 64.674Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0101 30.9617C89.6314 30.9617 88.5123 29.8495 88.5123 28.4784C88.5123 27.1073 89.6314 25.9951 91.0101 25.9951C92.3906 25.9951 93.5088 27.1073 93.5088 28.4784C93.5088 29.8495 92.3906 30.9617 91.0101 30.9617Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.163 95.0143L250.39 95.0143L264.788 80.7045L263.848 79.7711L249.839 93.6934L153.713 93.6934L128.81 68.9424L127.871 69.8767L153.163 95.0143Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.662 71.6186C125.686 70.6491 125.686 69.0764 126.662 68.1077C127.637 67.1373 129.22 67.1373 130.195 68.1077C131.171 69.0772 131.17 70.6491 130.195 71.6186C129.219 72.5882 127.637 72.5882 126.662 71.6186Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.759 0.50954C112.379 0.50954 111.26 -0.602655 111.26 -1.97375C111.26 -3.34484 112.379 -4.45703 113.759 -4.45703C115.139 -4.45703 116.257 -3.34484 116.257 -1.97375C116.257 -0.602654 115.139 0.50954 113.759 0.50954Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.571 16.4023L106.51 15.4679L95.8895 4.91309L38.7504 4.91308L38.7504 6.23398L95.3393 6.23398L105.571 16.4023Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8724 7.53689C37.4928 7.53689 36.3737 6.42469 36.3737 5.0536C36.3737 3.68251 37.4928 2.57031 38.8724 2.57031C40.252 2.57031 41.3711 3.68251 41.3711 5.0536C41.3711 6.42469 40.252 7.53689 38.8724 7.53689Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6434 55.0376L33.3432 42.4169L116.989 42.4169L130.215 29.2722L129.276 28.3379L116.438 41.096L32.793 41.096L19.7042 54.1042L20.6434 55.0376Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0283 56.0027C21.0528 56.9722 19.4703 56.9722 18.4956 56.0027C17.5192 55.0331 17.5201 53.4604 18.4956 52.4908C19.4711 51.5213 21.0528 51.5213 22.0292 52.4908C23.0047 53.4604 23.0047 55.0331 22.0283 56.0027Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.546 73.2284L167.057 73.2284L167.057 71.9075L152.096 71.9075L138.9 58.791L115.961 58.791L115.961 60.1119L138.349 60.1119L151.546 73.2284Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.091 62.1951C114.712 62.1951 113.593 61.0829 113.593 59.7118C113.593 58.3407 114.712 57.2285 116.091 57.2285C117.471 57.2285 118.59 58.3407 118.59 59.7118C118.59 61.0829 117.471 62.1951 116.091 62.1951Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.235 6.89779L156.362 6.89779L164.49 -1.17995L163.55 -2.11426L155.812 5.57689L123.235 5.57689L123.235 6.89779Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.37 9.09841C121.991 9.09841 120.872 7.98621 120.872 6.61512C120.872 5.24403 121.991 4.13184 123.37 4.13184C124.751 4.13184 125.869 5.24403 125.869 6.61512C125.869 7.98621 124.751 9.09841 123.37 9.09841Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.995 141.076L291.065 141.076L328.134 104.234L327.195 103.3L290.514 139.755L124.545 139.755L98.7312 114.101L11.4272 114.101L1.94635 123.524L2.88559 124.459L11.9774 115.422L98.1809 115.422L123.995 141.076Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.393 118.505L194.798 118.505L208.918 104.472L207.978 103.538L194.248 117.184L117.943 117.184L89.8302 89.2441L88.891 90.1784L117.393 118.505Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6847 91.1404C86.7101 90.1708 86.7101 88.5981 87.6847 87.6285C88.6612 86.659 90.2436 86.659 91.2192 87.6285C92.1939 88.5981 92.1939 90.1708 91.2192 91.1404C90.2436 92.1099 88.6612 92.1099 87.6847 91.1404Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.779 92.3921L134.254 92.3921L134.254 91.0712L108.329 91.0712L93.918 76.75L65.5943 76.75L65.5943 78.0709L93.3677 78.0709L107.779 92.3921Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7219 79.3739C64.3415 79.3739 63.2233 78.2626 63.2233 76.8915C63.2233 75.5195 64.3415 74.4082 65.7219 74.4082C67.1015 74.4082 68.2197 75.5195 68.2197 76.8915C68.2197 78.2626 67.1015 79.3739 65.7219 79.3739Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3616 115.886L73.3018 114.952L56.0777 97.833L38.5249 97.833L38.5249 99.1539L55.5275 99.1539L72.3616 115.886Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6526 100.458C37.2721 100.458 36.1531 99.3456 36.1531 97.9745C36.1531 96.6034 37.2721 95.4912 38.6526 95.4912C40.0313 95.4912 41.1504 96.6034 41.1504 97.9745C41.1504 99.3456 40.0313 100.458 38.6526 100.458Z",
    fill: "#EBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.17 128.73L211.093 128.73L235.742 104.232L234.802 103.299L210.543 127.409L158.17 127.409L158.17 128.73Z",
    fill: "url(#paint13_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 310.296,
    y1: 77.6866,
    x2: 59.1344,
    y2: 77.6865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 376.171,
    y1: 47.3991,
    x2: 14.5837,
    y2: 47.3991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 314.777,
    y1: 5.13813,
    x2: 81.3999,
    y2: 5.13811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 247.54,
    y1: 46.1158,
    x2: 90.8782,
    y2: 46.1158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 264.788,
    y1: 81.9783,
    x2: 127.871,
    y2: 81.9783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 106.51,
    y1: 10.6577,
    x2: 38.7504,
    y2: 10.6577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 130.215,
    y1: 41.6878,
    x2: 19.7042,
    y2: 41.6878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 167.057,
    y1: 66.0097,
    x2: 115.961,
    y2: 66.0097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 164.49,
    y1: 2.39177,
    x2: 123.235,
    y2: 2.39176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 328.134,
    y1: 122.188,
    x2: 1.94635,
    y2: 122.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 208.918,
    y1: 103.874,
    x2: 88.891,
    y2: 103.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 134.254,
    y1: 84.571,
    x2: 65.5943,
    y2: 84.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 73.3018,
    y1: 106.86,
    x2: 38.5249,
    y2: 106.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 235.742,
    y1: 116.014,
    x2: 158.17,
    y2: 116.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBFCFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontal);
export default __webpack_public_path__ + "static/media/Horizontal.645aa441a1a75ee2eea2420d7aa78c88.svg";
export { ForwardRef as ReactComponent };